const credentialRoutePatterns = [
  /^\/view-share\/[^/]+/,
  /^\/share\/view\/[^/]+/,
  /^\/sign\/[^/]+/,
  /^\/invite\/[^/]+/,
] as const;

const credentialRouteReplacements = [
  [/^\/view-share\/[^/]+/, '/view-share/[redacted]'],
  [/^\/share\/view\/[^/]+/, '/share/view/[redacted]'],
  [/^\/sign\/[^/]+/, '/sign/[redacted]'],
  [/^\/invite\/[^/]+/, '/invite/[redacted]'],
] as const;

export function isCredentialBearingPath(pathname: string): boolean {
  return credentialRoutePatterns.some((pattern) => pattern.test(pathname));
}

export function sanitizeAnalyticsPathname(pathname: string): string {
  for (const [pattern, replacement] of credentialRouteReplacements) {
    if (pattern.test(pathname)) {
      return pathname.replace(pattern, replacement);
    }
  }

  return pathname;
}
